<template>
  <div class="">
    <div>
      <b-tabs content-class="pt-1" lazy v-model="tabIndex">
        <b-tab
          v-for="(tab, index) in tabs"
          :key="index"
          @click="onTabClick(tab, index)"
          :title="tab.text"
          :active="active(index)"
          title-item-class="lisaweb"
        >
          <keep-alive>
            <component :is="selected"></component>
          </keep-alive>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Registries from "@/components/accounting/advance-payment/registries/index";
import Brokers from "@/components/accounting/advance-payment/brokers/index";
import UnsolvedPayments from "@/components/accounting/advance-payment/unsolved-payments/index";
import ShortcutsAndBreadcrumbsMixin from "@/mixins/ShortcutsAndBreadcrumbsMixin";

export default {
  mixins: [ShortcutsAndBreadcrumbsMixin],
  data() {
    return {
      // path: "module.PFOLIO",
      path: "book_entries.index",
      tabs: [
        { name: "Registries", text: "Clienti" },
        { name: "Brokers", text: "Produttori" },
        { name: "UnsolvedPayments", text: "Insoluti" },
      ],
      tabsGroup: "Management",
      bcs: [
        {
          text: "Contabilità",
          path: "",
          level: 0,
          disabled: true,
        },
        {
          text: "Contabilità",
          path: "",
          level: 1,
        },
        {
          text: "Prospetto Clienti e Produttori",
          path: "",
          level: 2,
        },
        {
          text: "Clienti",
          path: "book_entries.index",
          tab: `#${this.selected}`,
          level: 3,
        },
      ],
      maxLevel: 3,
      selected: "Registries",
      tabIndex: 0,
    };
  },
  components: {
    Registries,
    Brokers,
    UnsolvedPayments,
  },
};
</script>
